import { useDisclosure } from "@chakra-ui/react";
import { useCallback, useState } from "react";

export default function useSideDrawer<
  Item,
  ID extends string = string,
>(
  { getItemId }: { getItemId: (item?: Item) => ID | undefined },
) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedId, setSelectedId] = useState<ID>();
  const [selectedItem, setSelectedItem] = useState<Item>();

  const handleOnClose = useCallback(
    () => {
      setSelectedId(undefined);
      setSelectedItem(undefined);
      onClose();
    },
    [onClose],
  );

  const handleOpenDrawer = useCallback(
    (item: Item) => {
      setSelectedId(getItemId(item));
      setSelectedItem(item);
      onOpen();
    },
    [onOpen],
  );

  // this wraps an action and then returns a clickable handler function
  const expandClickHandlerByItem = useCallback(
    (item: Item) => {
      handleOpenDrawer(item);
    },
    [handleOpenDrawer],
  );

  const handleOpenDrawerById = useCallback(
    (id: ID) => {
      setSelectedId(id);
      onOpen();
    },
    [onOpen],
  );

  // this wraps an action and then returns a clickable handler function
  const expandClickHandlerById = useCallback(
    (id: ID) => {
      handleOpenDrawerById(id);
    },
    [handleOpenDrawerById],
  );

  return {
    isOpen,
    onClose: handleOnClose,
    selectedId,
    selectedItem,
    expandClickHandlerByItem,
    expandClickHandlerById,
  };
}
